import { SET_BULK_COST_ALLOCATION, SET_PARAMS_COST_ALLOCATION, CLEAR_PARAMS_COST_ALLOCATION } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_COST_ALLOCATION:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_COST_ALLOCATION:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_COST_ALLOCATION:
            return initialState;
        default:
            return state;
    }
}
